export default __webpack_public_path__ + "static/0305-4ca447bbdc1fe6e778b42bfefd874dbb.png";